/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Auto_Insert_Event_HelpInputs */

const en_options_editor_auto_insert_event_help = /** @type {(inputs: Options_Editor_Auto_Insert_Event_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The editor will automatically insert a new event based on the maximum number of lines found in the Event Group error settings.`)
};

const fr_options_editor_auto_insert_event_help = /** @type {(inputs: Options_Editor_Auto_Insert_Event_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'éditeur insère automatiquement un nouvel événement en fonction du nombre maximal de lignes défini dans les paramètres d'erreurs du groupe d'événements.`)
};

const de_options_editor_auto_insert_event_help = /** @type {(inputs: Options_Editor_Auto_Insert_Event_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Editor fügt automatisch ein neues Ereignis ein, basierend auf der maximalen Anzahl von Zeilen, die in den Fehlereinstellungen der Ereignisgruppe gefunden wurden.`)
};

const it_options_editor_auto_insert_event_help = /** @type {(inputs: Options_Editor_Auto_Insert_Event_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'editor inserirà automaticamente un nuovo evento in base al numero massimo di righe trovate nelle impostazioni di errore del gruppo eventi.`)
};

const ru_options_editor_auto_insert_event_help = /** @type {(inputs: Options_Editor_Auto_Insert_Event_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактор автоматически добавит новое событие, исходя из максимального количества строк, указанного в настройках ошибок группы событий.`)
};

const es_options_editor_auto_insert_event_help = /** @type {(inputs: Options_Editor_Auto_Insert_Event_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El editor insertará automáticamente un nuevo evento según la cantidad máxima de líneas encontradas en la configuración de error del Grupo de eventos.`)
};

const zh_cn2_options_editor_auto_insert_event_help = /** @type {(inputs: Options_Editor_Auto_Insert_Event_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑器将根据事件组错误设置中找到的最大行数自动插入新事件。`)
};

const ja_options_editor_auto_insert_event_help = /** @type {(inputs: Options_Editor_Auto_Insert_Event_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エディターは、イベント グループのエラー設定で見つかった行の最大数に基づいて、新しいイベントを自動的に挿入します。`)
};

const hi_options_editor_auto_insert_event_help = /** @type {(inputs: Options_Editor_Auto_Insert_Event_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट ग्रुप त्रुटि सेटिंग्स में पाई गई लाइनों की अधिकतम संख्या के आधार पर संपादक स्वचालित रूप से एक नया इवेंट सम्मिलित करेगा।`)
};

const pt_pt2_options_editor_auto_insert_event_help = /** @type {(inputs: Options_Editor_Auto_Insert_Event_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O editor irá inserir automaticamente um novo evento com base no número máximo de linhas encontrado nas configurações de erro do Grupo de Eventos.`)
};

/**
* | output |
* | --- |
* | "The editor will automatically insert a new event based on the maximum number of lines found in the Event Group error settings." |
*
* @param {Options_Editor_Auto_Insert_Event_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_auto_insert_event_help = /** @type {((inputs?: Options_Editor_Auto_Insert_Event_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Auto_Insert_Event_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_auto_insert_event_help(inputs)
	if (locale === "de") return de_options_editor_auto_insert_event_help(inputs)
	if (locale === "it") return it_options_editor_auto_insert_event_help(inputs)
	if (locale === "ru") return ru_options_editor_auto_insert_event_help(inputs)
	if (locale === "es") return es_options_editor_auto_insert_event_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_auto_insert_event_help(inputs)
	if (locale === "ja") return ja_options_editor_auto_insert_event_help(inputs)
	if (locale === "hi") return hi_options_editor_auto_insert_event_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_auto_insert_event_help(inputs)
	return en_options_editor_auto_insert_event_help(inputs)
});